import {
	List,
	ListItem,
	ListItemAvatar,
	Avatar,
	ListItemText,
} from "@mui/material";
import React from "react";
import { MailexUploadRulesDto } from "../../../models/MailexUploadRulesDto";
import FolderIcon from "@mui/icons-material/Folder";
import LockClock from "@mui/icons-material/LockClock";
import Description from "@mui/icons-material/Description";
import moment from "moment";

interface IMailexConfirmationStepProps {
	files: File[];
	rules: MailexUploadRulesDto;
}

export const MailexConfirmationStep: React.FC<IMailexConfirmationStepProps> = ({
	files,
	rules,
}) => {
	return (
		<div>
			<p>
				By clicking <b>Complete</b>, you confirm you want to upload the
				following files:
			</p>
			<List>
				{files.map((file, index) => {
					return (
						<ListItem key={`file-confirmation-mailex-${index}`}>
							<ListItemAvatar>
								<Avatar>
									<FolderIcon />
								</Avatar>
							</ListItemAvatar>
							<ListItemText primary={file.name} secondary={file.type} />
						</ListItem>
					);
				})}
			</List>
			<p>With the following rules:</p>
			<List>
				<ListItem key={`file-confirmation-rules-1`}>
					<ListItemAvatar>
						<Avatar>
							<LockClock />
						</Avatar>
					</ListItemAvatar>
					<ListItemText
						primary={moment(rules.datetime)
							.format("ddd MMM D, yyyy HH:mm")
							.toString()}
						secondary={"Scheduled for"}
					/>
				</ListItem>
				<ListItem key={`file-confirmation-rules-2`}>
					<ListItemAvatar>
						<Avatar>
							<Description />
						</Avatar>
					</ListItemAvatar>
					<ListItemText primary={rules.description} secondary={"Template"} />
				</ListItem>
			</List>
		</div>
	);
};
